import React from 'react';
import {Field, reduxForm} from 'redux-form';
import label from '../../utils/lngEn';
// import FormField from '../common/FormField';
// import Validate from '../common/formValidate';
import {Modal} from 'react-bootstrap';
import DropdownList from 'react-widgets/lib/DropdownList';
// import Multiselect from 'react-widgets/lib/Multiselect';

const renderDropdownList = ({ input, ...rest}) => <DropdownList {...input} {...rest}/>
// const renderMultiselect = ({ input,meta, ...rest }) =>
  // <Multiselect {...input}
  //              onBlur={() => input.onBlur()}
  //              value={input.value || []} // requires value to be an array
  //              {...rest}/>

const AddDiscouintlistsForm = (props) => {
  const {handleSubmit, submitting, onCancel, groupsArray, errorAmount, errorGroups, initialValues} = props;
  let isEdit = initialValues.group ? true : false ;
  return (
    <form onSubmit={handleSubmit} className="mt-4">
      <Field name="id" id="discountId" component="input" type="hidden"/>

      <div className="form-group">
        <label htmlFor="classes">Groups</label>
        <Field
          name="group"
          valueField="value"
          textField="option"
          data={groupsArray.map((group) => {
            return {
              'option': group.name,
              'value': group.id
            };
          })}
          component={renderDropdownList}
          disabled={isEdit}
        />
        <span className="input-description">Select group(s).</span>
        {errorGroups ?
          <div>
          <span className="text-danger">{errorGroups}</span>
          </div>
          :null}
      </div>
      <div className="form-group">
      <label htmlFor="kind">Discount</label>
        <Field
          name="amount"
          valueField="value"
          textField="option"
          data={[
            {option: '-10% Small Preference', value: '10'},
            {option: '-25% Big Preference', value: '25'},
            {option: '-50% Huge Preference', value: '50'},
            {option: '-100% Total Preference', value: '100'}]}
            
          component={renderDropdownList}
        />
        <span className="input-description">Choose an appropriate discount for the selected group(s).</span>
        {errorAmount ?
          <div>
          <span className="text-danger">{errorAmount}</span>
          </div>
          :null}
      </div>
      <Modal.Footer className="mt-4">
        <button type="button" onClick={onCancel} className="btn  btn-ter pull-left">Cancel</button>
        <button className="btn btn-primary pull-right" type="submit" disabled={submitting}>Save</button>
      </Modal.Footer>
    </form>
  )
}

export default reduxForm({
  form: 'AddDiscouintlistsForm'
})(AddDiscouintlistsForm);



// WEBPACK FOOTER //
// ./src/components/classes/AddDiscouintlistsForm.js